import { createContext, useContext } from "react";
import type { KeyedMutator } from "swr";
import type { Deal } from "~/models/Deal";

type DealContextValue = {
	deal: Deal;
	mutateDeal: KeyedMutator<Deal>;
};

export const DealContext = createContext<DealContextValue | null>(null);

export const useDealContext = (): Deal => useContext(DealContext)!.deal;

export const useMutateDealContext = (): KeyedMutator<Deal> =>
	useContext(DealContext)!.mutateDeal;
